import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "hints-input",
  relative: ""
}
const _hoisted_2 = { class: "hints" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Hint = _resolveComponent("Hint")
  const _component_ChatInputV2 = _resolveComponent("ChatInputV2")
  const _component_ChatInput = _resolveComponent("ChatInput")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.hints, ({pre, post}) => {
        return (_openBlock(), _createBlock(_component_Hint, {
          key: pre + post,
          class: "hint pointer",
          pre: pre,
          post: post,
          onClick: $event => ($options.setText(pre))
        }, null, 8 /* PROPS */, ["pre", "post", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($options.chat_2)
      ? (_openBlock(), _createBlock(_component_ChatInputV2, {
          key: 0,
          ref: "chat",
          modelValue: $data.input_text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.input_text) = $event)),
          shadow: "",
          fade: !_ctx.$responsive.desktop,
          controls: _ctx.$responsive.desktop,
          class: "chat-input",
          placeholder: _ctx.$responsive.mobile ? 'Ask anything...' : 'Ask anything, or type / to run a skill…',
          description: "Genrate can make mistakes. Check important information.",
          onRegenerate: $options.onChat
        }, null, 8 /* PROPS */, ["modelValue", "fade", "controls", "placeholder", "onRegenerate"]))
      : (_openBlock(), _createBlock(_component_ChatInput, {
          key: 1,
          ref: "chat",
          modelValue: $data.input_text,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.input_text) = $event)),
          shadow: "",
          fade: !_ctx.$responsive.desktop,
          controls: _ctx.$responsive.desktop,
          class: "chat-input",
          description: "Genrate can make mistakes. Consider checking important information.",
          onRegenerate: $options.onChat
        }, null, 8 /* PROPS */, ["modelValue", "fade", "controls", "onRegenerate"]))
  ]))
}